function BackedBy({ flexDirection = 'flex-col' }) {
  return (
    <div className={`flex gap-3 ${flexDirection}`}>
      <p className={`${flexDirection === 'flex-row' ? '' : 'mb-4'}`}>
        Backed by
      </p>
      <div className="flex gap-2 overflow-clip">
        {flexDirection === 'flex-row' ? (
          <img src="/images/backed-by.svg" alt="" srcSet="" />
        ) : (
          <>
            <img src="/images/techstars-logo.svg" className="block" alt="" />
            <img src="/images/oyester-logo.svg" className="block" alt="" />
            <img src="/images/resilience-logo.svg" className="block" alt="" />
          </>
        )}
      </div>
    </div>
  );
}

export default BackedBy;
